import { useEffect } from "react";

export default function ChatwootWidget() {
  useEffect(() => {
    console.log("ChatwootWidget MONTADO no browser");

    (function (d, t) {
      const BASE_URL = "https://chatwoot.atende24h.com.br";

      // Evita duplicar o script se recarregar o componente
      if (d.getElementById("chatwoot-script")) {
        console.log("Script do Chatwoot já existe, não vou injetar de novo.");
        return;
      }

      const g = d.createElement(t);
      const s = d.getElementsByTagName(t)[0];

      g.id = "chatwoot-script";
      g.src = BASE_URL + "/packs/js/sdk.js";
      g.async = true;
      s.parentNode.insertBefore(g, s);

      g.onload = function () {
        console.log("SDK do Chatwoot carregado:", window.chatwootSDK);

        if (!window.chatwootSDK) {
          console.error("Chatwoot SDK não definiu window.chatwootSDK");
          return;
        }

        window.chatwootSDK.run({
          websiteToken: "JCL1AvabsdPEAExtQPjgeUdo",
          baseUrl: BASE_URL,
        });
      };

      g.onerror = function (e) {
        console.error("Erro ao carregar script do Chatwoot:", e);
      };
    })(document, "script");
  }, []);

  return null;
}
